import mixins from "../../../less/mixins";

export default {
  defaultStyle: data => ({
    background: data.backgroundEngine,
    padding: '10px',
    '&:lang(ar)': {
      direction: 'rtl',
      textAlign: 'right'
    },
    '&$inDispoContainer' :{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        background: data.backgroundColor
      }
    },
    '&$portalDesign':{
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.15)',
      '&$engineMerged, &$inDispoContainer':{
        boxShadow: 'unset'
      }
    }
  }),
  inDispoContainer:{},
  engineContainerOpen: {
    height:'100%'
  },
  engineContainer: data => ({
    padding: '10px 10px 0',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      position: 'relative',
      zIndex: 300,
      padding: 0
    }
  }),
  engineHomeContainer: data => ({
    background: data.backgroundEngine,
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '0',
      position: 'relative',
      maxWidth: '980px',
      margin: '0 auto',
    },
  }),
  noDispoView: {
    padding: '0',
    position: 'relative',
    maxWidth: '980px',
    margin: '0 auto',
    background: data => data.backgroundEngine
  },
  dispoModal: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    width: '100%',
    bottom: '0',
    backgroundColor: '#00111b',
    zIndex: 500,
    padding: '50px 10px 0',
    ...mixins.boxSizing()
  },
  engine: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      position: 'relative',
      left: 0,
      right: 0,
      top: 0,
    },
    height: '100%',
  }),
  wrapperContainerDispo: {
    height:'100%',
    '& > div':{
      height:'100%',
    }
  },
  animationContainer: {},
  wrapperContainerHotelFile: {},
  searchContainer: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '20px',
      display: 'table',
      width: '100%',
      boxSizing: 'border-box',
    }
  }),
  searchContainerSlim: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '10px 20px'
    }
  }),
  dropDown: data => ({
    height:'100%',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      zIndex: 200,
      position: 'absolute',
      left: '20px',
      right: '20px',
      height:'auto'
    },
  }),
  dropDownDispoTop: data =>  ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      bottom: '100%',
    },
    '& $datepicker':{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before':{
          top: '100%',
          transform: 'rotate(180deg)',
        },
      },
    },
    '& $occups':{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before':{
          top: '100%',
          transform: 'rotate(180deg)',
        },
      },
    },
    '& $list':{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before':{
          top: '100%',
          transform: 'rotate(180deg)',
        },
      },
    }
  }),
  dropDownDispoBottom: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      top: 'calc(100% - 10px)',
    },
  }),
  dropDownDispo: {
    composes: '$dropDown',
    outline: 'none',
  },
  dropDownDispoMobile: {
    position: 'fixed',
    top: '100px',
    left: '10px',
    right: '10px',
    bottom: '10px',
    '& > div':{
      height:'100%'
    }
  },
  list: data => ({
    '&:before': {
      content: `''`,
      position: 'absolute',
      left: '11px',
      bottom: '100%',
      borderBottom: '0px solid #f6f6f6',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      marginBottom: '-1px',
      zIndex: 1,
      borderBottomWidth: '5px'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      '&:before': {
        left: '0',
        marginLeft: '15px',
        marginBottom: 0,
        borderBottom: '6px solid #fff',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent'
      }
    },
    '&:lang(ar)': {
      '&:before': {
        left: 'auto',
        right: '11px',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          left: 'auto',
          right: '0',
          marginLeft: 0,
          marginRight: '15px'
        }
      }
    }
  }),
  datepicker: data => ({
    '&:before': {
      content: `''`,
      position: 'absolute',
      left: '18px',
      bottom: '100%',
      borderBottom: '0px solid #f6f6f6',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      marginBottom: '-1px',
      zIndex: 1,
      borderBottomWidth: '5px'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      boxShadow: '0 3px 4px 0 rgba(0,0,0,.3)',
      '&:before': {
        left: '30%',
        marginBottom: 0,
        borderBottom: '6px solid #fff',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent'
      }
    },
    '&:lang(ar)': {
      '&:before': {
        left: 'auto',
        right: '11px',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          left: 'auto',
          right: '32%',
          marginLeft: '0',
          marginRight: '30px'
        }
      }
    }
  }),
  startSelected: data => ({
    '&:not($list):not($occups)':{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '39%',
        }
      },
      '&:lang(ar)': {
        left: 'auto',
        right: '45.47%',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          '&:before': {
            left: 'auto',
            right: '43%',
            marginLeft: '0',
            marginRight: '0'
          }
        }
      }
    },
  }),
  occups: data => ({
    '&:before': {
      content: `''`,
      position: 'absolute',
      left: '18px',
      bottom: '100%',
      borderBottom: '0px solid #f6f6f6',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      marginBottom: '-1px',
      zIndex: 1,
      borderBottomWidth: '5px'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      '&:before': {
        left: '48.3%',
        marginLeft: '30px',
        marginBottom: 0,
        borderBottom: '6px solid #fff',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent'
      }
    },
    '&:lang(ar)': {
      '&:before': {
        left: 'auto',
        right: '11px',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          left: 'auto',
          right: '50.7%',
          marginRight: '8px',
          marginLeft: 0
        }
      }
    }
  }),
  dropDownEnter: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity: 0,
      transition: 'opacity 0ms ease-out',
      transitionDelay: '2s'
    },
    /*'@media (min-width: 801px)': {
      transition: 'max-height 0ms ease-out',
      maxHeight: '0'
    }*/
  }),
  dropDownEnterActive: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity: 1,
      transition: 'opacity 300ms ease-out',
      transitionDelay: '.3s'
    },
    /*'@media (min-width: 801px)': {
      maxHeight: '300px',
      transition: 'max-height 600ms ease-out',
      overflow: 'hidden'
    }*/
  }),
  dropDownLeave: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity: 1,
      transition: 'opacity 300ms ease-out'
    },
    /*'@media (min-width: 801px)': {
      maxHeight: '300px',
      transition: 'max-height 500ms ease-out',
      overflow: 'hidden'
    }*/
  }),
  dropDownLeaveActive: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity: 0,
      transition: 'opacity 300ms ease-out'
    },
    /*'@media (min-width: 801px)': {
      transition: 'max-height 500ms ease-out',
      maxHeight: '0'
    }*/
  }),
  dropDownEnterDatepicker: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity: 0,
      transition: 'opacity .3s ease-out',
      transitionDelay: '.3s'
    },
    /*'@media (min-width: 801px)': {
      transition: 'max-height 0ms ease-out',
      maxHeight: '0'
    }*/
  }),
  dropDownEnterActiveDatepicker: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity: 1,
      transition: 'opacity 300ms ease-out',
      transitionDelay: '.3s'
    },
    /*'@media (min-width: 801px)': {
      maxHeight: '300px',
      transition: 'max-height 600ms ease-out',
      overflow: 'hidden'
    }*/
  }),
  dropDownLeaveDatepicker: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity:0
    },
    /*'@media (min-width: 801px)': {
      maxHeight: '300px',
      transition: 'max-height 500ms ease-out',
      overflow: 'hidden'
    }*/
  }),
  dropDownLeaveActiveDatepicker: data => ({
    [`@media (max-width: ${data.modalBreak - 1}px)`]: {
      opacity: 0
    },
    /*'@media (min-width: 801px)': {
      transition: 'max-height 500ms ease-out',
      maxHeight: '0'
    }*/
  }),
  dropDownExitDoneDatepicker:{
    display:'none'
  },
  flyHotelEnter: {
    transition: 'max-height 0ms ease-out',
    maxHeight: '0',
    transitionDelay: '.3s',
    marginBottom: 0
  },
  flyHotelEnterActive: {
    maxHeight: '100px',
    transition: 'max-height 300ms ease-out,margin-bottom .3s ease-out',
    overflow: 'hidden',
    transitionDelay: '.3s',
    marginBottom: '0'
  },
  closeButton: data => ({
    position: 'absolute',
    top: '10px',
    right: '10px',
    color: data.mainColor,
    zIndex: '501',
    width: '24px',
    height: '24px',
    '& > span': {
      fontSize: '16px',
      lineHeight: '1px'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      marginTop: '-12px',
      top: '50%',
      right: '-30px',
    },
    '&:lang(ar)': {
      right: 'auto',
      left: '10px',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        right: 'auto',
        left: '-10px'
      }
    }
  }),
  closeButtonClose: data => ({
    position: 'absolute',
    top: '20px',
    right: '-8px',
    color: data.mainColor,
    zIndex: '501',
    width: '24px',
    height: '24px',
    '& > span': {
      fontSize: '16px',
      lineHeight: '1px'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      marginTop: '-12px',
      top: '50%',
      right: '-10px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: '-8px',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        right: 'auto',
        left: '-10px'
      }
    }
  }),
  clearText: data => ({
    fontSize: '12px',
    lineHeight: '40px',
    position: 'absolute',
    right: '0',
    top: '0',
    color: '#b2b2b2',
    zIndex: '1',
    width: '30px',
    textAlign: 'center',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      lineHeight: '50px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: 0
    }
  }),
  engineFooter:{
    display:'table',
    width:'100%',
  },
  engineFooterElement:{
    display:'table-cell',
    verticalAlign:'middle',
  },
  promo:{
    '&:before':{
      content:'none'
    }
  },
  engineFileContainer: data =>({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '0',
      position: 'relative',
      margin: '0 auto'
    },
    '&$dispoModal':{
      padding:'50px 10px 0'
    },
    '& $datepicker': {
      '&$startSelected':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          '&:before': {
            left: '40%',
          }
        },
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '31%',
        }
      },
    },
    '& $occups': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '50.5%',
        }
      },
    },
    '& $dropDown':{
      margin: '0 0 0 auto',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        top:'auto'
      },
      '&:lang(ar)': {
        margin: '0 auto 0 0'
      }
    },
    '& $dropDownDispoBottom':{
      '& $datepicker':{
        '&:before':{
          bottom: '100%',
        },
      },
      '& $occups':{
        '&:before':{
          bottom: '100%',
        },
      }
    },
  }),
  promoWiMode: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      maxWidth: '980px',
    },
    '& $occups': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '40%',
        }
      },
      '&:lang(ar)':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          '&:before': {
            left: 'auto',
            right:'44%'
          }
        },
      },
    },
    '& $datepicker': {
      '&$startSelected':{
        '&:before': {
          [`@media (min-width: ${data.modalBreak}px)`]: {
            left: '12.7%',
          }
        },
        '&:lang(ar)':{
          [`@media (min-width: ${data.modalBreak}px)`]: {
            '&:before': {
              left: 'auto',
              right:'25%'
            }
          },
        },
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '3%',
        }
      },
      '&:lang(ar)':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          '&:before': {
            left: 'auto',
            right:'3%'
          }
        },
      },
    },
    '& $dropDownDispoTop':{
      '& $datepicker':{
        '@media (min-width: 801px)': {
          '&:before':{
            top: '100%',
            transform: 'rotate(180deg)',
          },
        },
      },
      '& $occups':{
        '@media (min-width: 801px)': {
          '&:before':{
            top: '100%',
            transform: 'rotate(180deg)',
          },
        },
      }
    },
    '& $dropDownDispoBottom':{
      '& $datepicker':{
        '@media (min-width: 801px)': {
          '&:before':{
            bottom: '100%',
          },
        },
      },
      '& $occups':{
        '@media (min-width: 801px)': {
          '&:before':{
            bottom: '100%',
          },
        },
      }
    },
  }),
  promoWiModeSmall: data => ({
    '& $occups': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '47.5%',
        }
      },
      '&:lang(ar)':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          '&:before': {
            left: 'auto',
            right:'50%'
          }
        },
      },
    },
    '& $datepicker': {
      '&$startSelected':{
        '&:before': {
          [`@media (min-width: ${data.modalBreak}px)`]: {
            left: '32%',
          }
        },
        '&:lang(ar)':{
          [`@media (min-width: ${data.modalBreak}px)`]: {
            '&:before': {
              left: 'auto',
              right:'35%'
            }
          },
        },
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          left: '137px',
        }
      },
      '&:lang(ar)':{
        [`@media (min-width: ${data.modalBreak}px)`]: {
          '&:before': {
            left: 'auto',
            right:'137px'
          }
        },
      },
    },
  }),
  DESK :{
    textAlign: 'right',
  },
  inputEngineTitle:{},
  searchContainerChildren:{},
  MOBIL:{},
  TABLET:{},
  engineMerged:{},
  searchContainerChildren:{},
  inputEngineTitle:{},
  portalDesign: data => ({
    padding: '50px 10px 0',
    '& $dropDown':{
      [`@media (min-width: ${data.modalBreak}px) and (max-width:1200px)`]:{
        '&$engineMerged':{
          position: 'fixed',
          padding: '0 10px',
          top: '12%',
          '& $list':{
            '&:before':{
              left: '20%'
            }
          },
          '& $datepicker':{
            '&:before':{
              left: '40%'
            },
            '&$startSelected':{
              '&:before':{
                left: '45%'
              }
            }
          }
        },
      }
    },
    '&:not($dispoModal)':{
      padding:'0',
      margin: '0 13px',
      maxWidth:'1200px',
      '&$inDispoContainer':{
        paddingRight: '40px',
        '& $searchContainerChildren':{
          display: 'flex',
          height: '100%',
          alignItems: 'flex-end',
          '& $inputEngineTitle':{
            position: 'absolute',
            top: '0',
            left: '0',
          }
        }
      },
      //height: 'unset',
      '& $searchContainer':{
        [`@media (min-width: ${data.modalBreak}px)`]:{
          display:'flex',
          padding:0,
        }
      },
      '& $clearText': {
        [`@media (min-width: ${data.modalBreak}px)`]: {
          lineHeight: '54px',
          top:'auto',
          bottom:0
        },
      },
      '& $dropDown':{
        [`@media (min-width: ${data.modalBreak}px)`]:{
          top:'90px',
          left:'0',
          right:'0',
          maxWidth:'none'
        },
        '& $datepicker':{
          '&:before':{
            [`@media (min-width: ${data.modalBreak}px)`]:{
              left:'33%',
            },
          },
          '&:lang(ar)':{
            '&:before':{
              [`@media (min-width: ${data.modalBreak}px)`]:{
                right: 'auto',
                left: '63%',
              }
            }
          },
          '&$startSelected':{
            '&:before':{
              [`@media (min-width: ${data.modalBreak}px)`]:{
                left:'42%'
              },
            },
            '&:lang(ar)':{
              '&:before':{
                [`@media (min-width: ${data.modalBreak}px)`]:{
                  left: '53%',
                }
              }
            },
          },
          '&$list':{
            [`@media (min-width: ${data.modalBreak}px)`]: {
              '&:before': {
                left: '0'
              },
              '&:lang(ar)':{
                '&:before': {
                  left: 'auto',
                  right: '0',
                }
              }
            }
          },
          [`@media (min-width: ${data.modalBreak}px)`]: {
            background:'#fff',
            paddingBottom:0,
            maxWidth:'none',
            boxShadow:'none',
            '&:lang(ar)':{
              marginRight: '0',
            },
            '& > div':{
              boxShadow:'none'
            }
          }
        },
        '& $occups':{
          '&:before':{
            [`@media (min-width: ${data.modalBreak}px)`]:{
              left:'52%'
            }
          },
          '&:lang(ar)':{
            '&:before':{
              [`@media (min-width: ${data.modalBreak}px)`]:{
                right:'auto',
                left: '44.5%',
              }
            }
          },
          [`@media (min-width: ${data.modalBreak}px)`]: {
            background:'transparent !important'
          },
        }
      },
      '& $dropDownDispoTop':{
        [`@media (min-width: ${data.modalBreak}px)`]:{
          bottom: 'calc(100% + 10px)',
        },
        '& $datepicker':{
          '&:before':{
            top: '100%',
            transform: 'rotate(180deg)',
          },
        },
        '& $occups':{
          '&:before':{
            top: '100%',
            transform: 'rotate(180deg)',
          },
        }
      },
      '& $dropDownDispoBottom':{
        [`@media (min-width: ${data.modalBreak}px)`]:{
          top:'calc(100% + 10px)',
        },
        '& $datepicker':{
          '&:before':{
            bottom: '100%',
          },
        },
        '& $occups':{
          '&:before':{
            bottom: '100%',
          },
        }
      },
      '& $animationContainer':{
        maxWidth:'none',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          filter:'drop-shadow(0px 2px 5px rgba(0,0,0,50%))',
        }
      },
      [`@media (min-width: ${data.modalBreak}px)`]:{
        margin:'0 auto'
      }
    }
  }),
  roundedTheme:{
    '&$dispoModal':{
      paddingTop: '100px'
    },
    '& $list':{
      '&:before': {
        content: 'unset',
      }
    },
    '& $datepicker':{
      borderRadius: '25px',
      '&:before': {
        content: 'unset',
      }
    },
    '& $occups':{
      '&:before': {
        content: 'unset',
      }
    },
    '& $closeButton':{
      display: 'none',
    },
    '& $dropDownDispoMobile':{
      top: '160px'
    }
  },
  promoDisable:{},
};
